module.exports = __webpack_public_path__ + "img/edit.09cf8d79.svg";